import React from "react";
import { Box, Typography } from "@mui/material";

export const TEMPLATE_WIDTH = 3508;
export const TEMPLATE_HEIGHT = 2480;

export const config = {
  width: TEMPLATE_WIDTH,
  height: TEMPLATE_HEIGHT,

  regions: [
    {
      id: "model",
      x: 0.05,
      y: 0.12,
      width: 0.65,
      height: 0.75,
    },
    {
      id: "detail1",
      x: 0.75,
      y: 0.12,
      width: 0.2,
      height: 0.23,
    },
    {
      id: "detail2",
      x: 0.75,
      y: 0.38,
      width: 0.2,
      height: 0.23,
    },
    {
      id: "detail3",
      x: 0.75,
      y: 0.64,
      width: 0.2,
      height: 0.23,
    },
  ],

  textFields: [
    {
      id: "marca",
      x: 0.05,
      y: 0.02,
      width: 0.35,
      height: 0.06,
      fontSize: 56,
      fontWeight: "bold",
      color: "#ffffff",
      backgroundColor: "grey.800",
    },
  ],
};

function LookbookPreview({ marca = "MARCA", className }) {
  return (
    <Box
      className={className}
      sx={{
        position: "relative",
        aspectRatio: `${TEMPLATE_WIDTH}/${TEMPLATE_HEIGHT}`,
        bgcolor: "#fff",
        border: "1px solid #ccc",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "2%",
          width: "35%",
          height: "6%",
          bgcolor: "grey.800",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{ color: "white", fontWeight: "bold", fontSize: ".3rem" }}
        >
          {marca}
        </Typography>
      </Box>

      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "12%",
          width: "65%",
          height: "75%",
          border: "1px dashed",
          bgcolor: "#eee",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: "75%",
          top: "12%",
          width: "20%",
          height: "23%",
          border: "1px dashed",
          bgcolor: "#eee",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: "75%",
          top: "38%",
          width: "20%",
          height: "23%",
          border: "1px dashed",
          bgcolor: "#eee",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: "75%",
          top: "64%",
          width: "20%",
          height: "23%",
          border: "1px dashed",
          bgcolor: "#eee",
        }}
      />
    </Box>
  );
}

export default LookbookPreview;
